import { FormikProps } from 'formik';
import { DocumentNode } from 'graphql';
import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';

import {
  ClientDepartmentStatus,
  ClientLocationStatus,
  ContentEmailSpecInput,
  ContentEmailSpecMutation,
  CreateClientDepartmentInput,
  CreateClientDisclosureInput,
  CreateClientLocationInput,
  LeaderboardEventScoreInput,
  ManualNotificationsItem,
  ManualNotificationsItemInput,
} from 'api';

export type EditableList = EditableListType.Departments | EditableListType.Locations;
export type FormikMessage = FormikProps<ManualNotificationsItemInput | ManualNotificationsItem>;
export type GraphQLResponse = (values: object) => void;
export type IDepartmentLocation = Partial<CreateClientDepartmentInput | CreateClientLocationInput>;
export type IDisclosure = Partial<CreateClientDisclosureInput>;
export type ContentEmailValues = ContentEmailSpecMutation | ContentEmailSpecInput;

export interface IDepartmentsLocationsOptions {
  createMutation: DocumentNode;
  updateMutation: DocumentNode;
  createResponse: GraphQLResponse;
  updateResponse: GraphQLResponse;
  createReducer: (cache: DataProxy, result: FetchResult) => void;
  deleteReducer: (cache: DataProxy, result: FetchResult) => void;
  activeStatus: {
    department_status?: ClientDepartmentStatus;
    location_status?: ClientLocationStatus;
  };
  disabledStatus: {
    department_status?: ClientDepartmentStatus;
    location_status?: ClientLocationStatus;
  };
}

export enum EditableListType {
  Departments = 'departments',
  Locations = 'locations',
}

export interface ILeaderboardScores {
  eventScores: [LeaderboardEventScoreInput];
}
